import { render, staticRenderFns } from "./waiting_room.vue?vue&type=template&id=19295d68&scoped=true"
import script from "./waiting_room.vue?vue&type=script&lang=js"
export * from "./waiting_room.vue?vue&type=script&lang=js"
import style0 from "./waiting_room.vue?vue&type=style&index=0&id=19295d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19295d68",
  null
  
)

export default component.exports